import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {TextCharLimit, Stack, Box, Typography, Button, Paper, Divider} from 'views/components';
import {translate, Translate, MarkdownEditor} from 'views/module';
import {useNavigate} from 'views/module';

import backend from 'utils/backend';

const DEFAULT_CAREGIVER_DATA = {
  caregiverName: '',
  description: {
    blob: '',
    editorType: 'MARKDOWN',
  },
};

const NewCaregiver = (props) => {
  const [newCaregiverData, setNewCaregiverData] = React.useState(DEFAULT_CAREGIVER_DATA);
  const [newCaregiverDataValid, setNewCaregiverDataValid] = React.useState(false);

  const navigate = useNavigate();

  const progressWrap = props.statusProgressWrap;

  const caregiverName = newCaregiverData.caregiverName || '';
  const description = newCaregiverData?.description?.blob || '';

  const setcaregiverName = (newValue) => {
    setNewCaregiverData((e) => {
      return {
        ...e,
        caregiverName: newValue,
      };
    });
  };
  const setDescription = (newValue) => {
    setNewCaregiverData((e) => {
      return {
        ...e,
        description: {
          blob: newValue,
          editorType: 'MARKDOWN',
        },
      };
    });
  };

  React.useEffect(() => {
    setNewCaregiverDataValid(Boolean(caregiverName));
  }, [caregiverName]);

  const isSubmitDisabled = () => {
    return !newCaregiverDataValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    progressWrap(async () => {
      const result = await backend.caregiver.createCaregiver(newCaregiverData);

      navigate(`/caregiver/${result.caregiverRn}`);
    });
  };

  return (
    <Paper sx={{p: {xs: 1, md: 2}}}>
      <Stack direction='column' spacing={2} wrap='nowrap'>
        <Box>
          <Typography variant='h4' sx={{fontWeight: 500}}>
            <Translate expression='caregiver.CaregiverNew.Title' />
          </Typography>
        </Box>
        <Divider variant={'middle'}/>
        <Box>
          <TextCharLimit
            label={translate('caregiver.CaregiverNew.CaregiverName')}
            value={caregiverName}
            onChange={setcaregiverName}
            charLimit={180}
          />
        </Box>
        <Stack spacing={1}>
          <Box sx={{display: 'flex', alignContent: 'left'}}>
            <Typography variant='description1' sx={{fontWeight: 500}}>
              <Translate expression='caregiver.CaregiverNew.CaregiverDescription' />
            </Typography>
          </Box>
          <Box xs={12}>
            <MarkdownEditor
              value={description}
              onChange={setDescription}
            />
          </Box>
        </Stack>
        <Box>
          <Stack>
            <Button
              color={'primary'}
              disabled={isSubmitDisabled()}
              onClick={handleSubmit}
              label={translate('caregiver.CaregiverNew.CreateNewCaregiver')}
              sx={{
                p: '8px 22px 8px 22px',
              }}
            />
            <Button
              variant='text'
              href='/caregiver'
              label={translate('generic.Cancel')}
              sx={{
                'textTransform': 'none',
                'textDecoration': 'underline',
                'fontSize': '12px',
                'fontWeight': 'bold',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}/>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

NewCaregiver.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NewCaregiver));
